import React, { useState } from 'react';
import { Emails } from '../../_shared/lib/emails';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { sendEmail } from '../../_shared/services/email.service';
import { Button } from '../../_shared/button';
import { Input, message } from 'antd';
import { TableTitleHeader } from '../../_shared/table-list';
import { Row } from '../../_shared/row';
import { getRoleName, getMyOrg } from '../../utils';
import { AppState } from '../../app.state';

export const FeedbackForm = (props: any) => {
    const [state, setState] = useState({
        loading: false,
        feedback: '',
    })
    
    const sState = useSelector((s: AppState) => s);

    const changeText = (e: any) => {
        const val = e.target.value;
        setState(s => ({ ...s, feedback: val }))
    }
    
    const sendFeedback = async () => {
        try {
            setState(s => ({ ...s, loading: true }))
            
            const user = get(sState, 'auth.user', {});
            const org = getMyOrg(sState);
            const roleId = get(user, 'role');
            const roleName = roleId != null ? getRoleName(roleId as number, sState) : '';

            const email = Emails.feedback({
                ToAddresses: ['bruce@go-helios.com', 'danielle@go-helios.com'],
                props: {
                    ...user,
                    feedback: state.feedback,
                    roleName,
                    orgName: org ? org.name : '',
                }
            })
    
            await sendEmail(email);

            setState(s => ({ ...s, feedback: '' }))

            message.success('Feedback submitted successfully!')
        } catch (err) {
            message.error((err as Error).toString());
        } finally {
            setState(s => ({ ...s, loading: false }))
        }
    }

    return (
        <div>
            <TableTitleHeader>What can we improve?</TableTitleHeader>
            <p style={{ color: '#888', marginTop: 4, marginBottom: 0, fontSize: 13 }}>Please do not submit any personally identifiable information through this form.</p>

            <Input.TextArea style={{ margin: '10px 0' }} placeholder='Enter Feedback Here' onChange={changeText} rows={4} value={state.feedback} />
            
            <Row center>
                <Button title="Submit" disabled={!state.feedback} loading={state.loading} onClick={sendFeedback} />
            </Row>
        </div>
    )
}